import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-downloading-offline-modal',
  templateUrl: './downloading-offline-modal.component.html',
  styleUrls: ['./downloading-offline-modal.component.scss'],
  standalone: false
})
export class DownloadingOfflineModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
